import React, { useContext, useEffect, useState } from 'react';
import './ClientPortal.css'
import ClientPortalHeader from "./ClientPortalHeader";
import EstimateAndCompanyInfo from "./EstimateAndCompanyInfo"
import ContactInformation from "./ContactInformation";
import MovingConsultant from "./MovingConsultant";
import PackingMaterials from "./PackingMaterials";
import EstimateStatistics from "./EstimateStatistics";
import MapContainer from "../CommonComponents/GoogleMap"
import EstimateAddress from "./EstimateAddress";
import EstimateDetails from "./EstimateDetails";
import EstimateNotes from "./EstimateNotes";
import CompanyNote from "./CompanyNote";
import DefaultModal from "../CommonComponents/DefaultModal"
import DefaultAlerts from "../CommonComponents/DefaultAlerts";
import CompanyText from "./CompanyText"
import FileUpload from "./FileUpload";
import LinkExpired from "./LinkExpired";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import ScheduledEvents from "./ScheduledEvents";
import axios from "axios";
import {Elink, UpdateRelocationUrl} from "../CommonComponents/Routes";


const ClientPortal = () => {
    let RecordsController = useContext(RecordsManagementContext)
    let  backgroundColor1 = RecordsController.CP_PageDetails.EstimateAndCompanyInfo.Estimate.BgColor1 // used to set the background color of the client portal according to the setting in moveitpro.
    let  backgroundColor2 = RecordsController.CP_PageDetails.EstimateAndCompanyInfo.Estimate.BgColor2
    let showRelocation = RecordsController.CP_PageDetails.ShowRelocationInsurance
    let relocationChecked = RecordsController.CP_PageDetails.RelocationChecked
    let IsJobOpen = RecordsController.IsJobOpen
    let  ViewManagement = useContext(ViewMangementContext)
    function getPos(el) { //used to update position of google-map div container in dom w.r.t window size change and move it from bottom to specified div position.
        let currentPos = el.getBoundingClientRect()
        for (var lx = 0, ly = 0;
            el != null;
            lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
        let pos = { x: lx, y: ly, height: currentPos.height, width: currentPos.width }
        document.getElementById('map_canvas').style.cssText = `position:absolute;top:${pos.y}px;left:${pos.x}px;height:${pos.height}px; width:${pos.width}px;overflow:hidden`
    }

    const [isChecked, setIsChecked] = useState(relocationChecked);
    const [isDisabled, setIsDisabled] = useState(!IsJobOpen);
    const UpdateRelocation = async (relocation_insurance) => {
        let cookie = document.cookie.split('employee_id=')[1];
        setIsChecked(!isChecked);
        relocation_insurance = relocation_insurance === true ? "1" : "0"
        axios({
            method: 'post',
            url: UpdateRelocationUrl,
            params: {estimate_key: Elink, employee_key: cookie, relocation_insurance: relocation_insurance}
        }).then((response) => { //
            let Message = response.data.Message
            //shows the success message if relocation insurance update successfully.
            ViewManagement.setAlertProperty({
                Message: Message.Text,
                Type: Message.Type,
                Show: true,
                AutoHide: true
            })
        })
    }

    useEffect(() => {
        var el = document.getElementById('map-container-div')
        if (el) {
            window.addEventListener('resize', () => { getPos(el) });
            window.addEventListener('scroll', () => { getPos(el) });
            getPos(el)
        }
    }, [])

    return (// if Estimate duplicate setting is "On" for an estimate than it will show link Expired page otherwise show client portal.
        RecordsController.CP_PageDetails.EstimateIsDuplicate ?
            <LinkExpired/>
            :
        <div  style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className="width-wrapper">
                <DefaultAlerts/>
                <DefaultModal/>
                <ClientPortalHeader/>
                <div className="estimate-services-wrap py-4">
                    <div className="container">
                        <EstimateAndCompanyInfo/>
                        <CompanyText/>
                        <div className="row pt-4">
                            <div className="col-lg-4">
                                <ContactInformation/>
                                <MovingConsultant/>
                                <PackingMaterials/>
                                <FileUpload/>
                            </div>
                            <div className="col-lg-8">
                                <EstimateStatistics/>
                                <div className="map-img pt-4" id='map-container-div' style={{ height: '300px', width: '100%' }}>
                                        {/* <MapContainer/> */}
                                </div>
                                <EstimateAddress/>
                                <ScheduledEvents/>
                                <EstimateDetails/>
                            </div>
                        </div>
                        {showRelocation ? <><div style={{color: "#26a9e0", position: "relative", top: "12px"}}><h6>Would you like Relocation Insurance? <input type="checkbox" checked={isChecked} disabled = {isDisabled}  onChange={(e) => UpdateRelocation(e.target.checked)}/></h6></div></> : ""}
                        <EstimateNotes/>
                        <CompanyNote/>
                    </div>
                </div>
                <a href="https://www.moveitpro.com/privacy-policy" target="_blank" className="footer-link pt-3 ml-4">Privacy
                    Policy</a>
            </div>
        </div>
    );
}
export default ClientPortal;